import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './components';
import Author from './components/Author/Author';
import { routes } from './routes';
import { setLanguage } from './store/features/common/common.slice';
const useQuery = () => new URLSearchParams(window.location.search);

const App: React.FC = () => {
    const dispatch = useDispatch();
    const query = useQuery();
    const embedded = query.get('embedded');
    const lang = query.get('lang');

    useEffect(() => {
        if (lang) dispatch(setLanguage(lang));
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/loans" />} />

                {routes.map(({ path, Element }, index) => (
                    <Route
                        key={index}
                        path={path}
                        element={
                            <>
                                {embedded === 'true' ? null : <Header />}
                                <Element />
                                {embedded === 'true' ? null : <Author />}
                            </>
                        }
                    />
                ))}

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
};

export default App;
